import { render, staticRenderFns } from "./dtunes-otp-input.vue?vue&type=template&id=74953068&scoped=true&"
import script from "./dtunes-otp-input.vue?vue&type=script&lang=js&"
export * from "./dtunes-otp-input.vue?vue&type=script&lang=js&"
import style0 from "./dtunes-otp-input.vue?vue&type=style&index=0&id=74953068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74953068",
  null
  
)

export default component.exports